export default __webpack_public_path__ + "static/media/shield.20236319.png";